import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { firestorePlugin } from 'vuefire'
import Firebase from 'firebase/app'
import 'firebase/firestore'
import Toasted from 'vue-toasted'
Vue.use(firestorePlugin)
Vue.use(Toasted, {position:'top-center', duration:4000, type:'success', theme:'outline'})

Vue.config.productionTip = false
let app = ''


// Initialize Firebase
var config = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
};


Firebase.initializeApp(config);
export const db = Firebase.firestore()
var store = {
  state: {
    uid: null,
    isAdmin: false,
    accessLevel: 0,
    username: "",
    org: null,
  },
  setUid (newUid, name="") {
    if (name.length > 0) {
      this.state.username = name
    }
    this.state.uid = newUid;
  },
  setRoles (admin, access, org) {
    this.state.isAdmin = admin;
    this.state.accessLevel = access;
    this.state.org = org;
  },
  refreshState () {
    this.state.uid = null;
    this.state.isAdmin = false;
    this.state.username = "";
    this.state.accessLevel = 0;
    this.state.org = null;
  }
}


Firebase.auth().onAuthStateChanged(user => {
  if (user) {
    db.collection('whitelist').doc(user.email).get().then(function(doc) {
      if (doc.exists) {
        var userData = doc.data();
        store.setUid(user.uid, user.displayName)
        store.setRoles(userData.admin, userData.accessLevel, userData.org)
        router.push('detentions')
      }
    })
  } else {
    store.refreshState();
  }


  if (!app) {
    app = new Vue({
      data: {
        sharedState: store.state
      },
      router,
      render: h => h(App)
    }).$mount('#app')
  }
})
